import { render, staticRenderFns } from "./addone.vue?vue&type=template&id=45070f60&scoped=true"
import script from "./addone.vue?vue&type=script&lang=js"
export * from "./addone.vue?vue&type=script&lang=js"
import style0 from "./addone.vue?vue&type=style&index=0&id=45070f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45070f60",
  null
  
)

export default component.exports